<template>
  <el-dialog
    title=""
    :visible="showModal"
    :show-close="false"
    width="600px"
    class="ts-modal modal-image"
  >
    <!-- <button type="button" aria-label="Close" class="el-dialog__headerbtn" @click="onCloseDialog(null)"><i class="el-dialog__close el-icon el-icon-close"></i></button> -->
    <figure class="img-container">
      <img src="../../../assets/img/congrats.png" alt="Triage" />
    </figure>

    <div style="text-align:center;">
      <span class="h5">Congratulations!</span>

      &nbsp;&nbsp;

      <p>
        <b
          >Congratulations on being offered the role
          <u>{{ jobSeekerInfo.roleTitle }}</u
          >.</b
        ><br />
      </p>
      <p>
        If you agree to this offer, you will become an employee for
        <u>{{ jobSeekerInfo.companyName }}</u> <br />
        and will no longer be a Job Seeker.
      </p>
      <p>
        You will be sent an email with your new company TalentSensus login
        details.
      </p>
    </div>

    &nbsp;&nbsp;

    <el-row>
      <el-col :xl="8" :lg="8" :md="8" :sm="24" :xs="24">
        <button
          class="ts-btn ts-btn-small"
          style="width: 90%;margin: auto;"
          @click="acceptJobOffer"
        >
          Accept Job Offer
        </button>
      </el-col>
      <el-col :xl="8" :lg="8" :md="8" :sm="24" :xs="24">
        <button
          class="ts-btn ts-btn-small ts-btn-white"
          style="width: 90%;margin: auto;"
          @click="declineJobOffer"
        >
          Decline
        </button>
      </el-col>
      <el-col :xl="8" :lg="8" :md="8" :sm="24" :xs="24">
        <button
          class="ts-btn ts-btn-small ts-btn-white"
          style="width: 90%;margin: auto;"
          @click="onCloseDialog(null)"
        >
          Go Back
        </button>
      </el-col>
    </el-row>
    <!-- <loading 
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="false">
    </loading> -->

    <TSLoading
      :active="isLoading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process the data...'"
    />
  </el-dialog>
</template>

<script>
import * as signalR from "@aspnet/signalr";
import TSLoading from "../../../components/TSLoading.vue";

export default {
  components: {
    TSLoading
  },
  created() {
    this.jobSeekerInfo = this.$route.params.data;

    //create signalR connection
    this.huburl = process.env.VUE_APP_MESSAGE_BASE_URI;
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(this.huburl, {
        transport:
          signalR.HttpTransportType.WebSockets |
          signalR.HttpTransportType.LongPolling,
        "content-type": "application/json",
        accessTokenFactory: () => localStorage.getItem("token")
      })
      .build();

    this.connection.start().catch(function(err) {
      return console.error(err.toString());
    });
  },
  data() {
    return {
      isLoading: false,
      showModal: true,
      jobSeekerInfo: {}
    };
  },
  methods: {
    onCloseDialog(done) {
      this.showModal = false;
      this.$router.push({
        name: "jobseeker-statusboard",
        params: { activeTab: "third" }
      });
    },
    declineJobOffer() {
      this.isLoading = true;
      this.$store
        .dispatch("jobseeker/cancelJobMatch", this.jobSeekerInfo.talentPoolId)
        .then(res => {
          // this.connection.invoke("SendMessageToAdmin", "Employee Added").catch(function(err){
          //   return console.error(err.toString());
          // });
          this.isLoading = false;
          this.showModal = false;
          this.$message.success("You have declined the job offer.");
          this.$router.push({
            name: "jobseeker-statusboard",
            params: { activeTab: "third" }
          });
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    acceptJobOffer() {
      this.isLoading = true;
      this.$store
        .dispatch("jobseeker/acceptJobOffer", this.jobSeekerInfo.talentPoolId)
        .then(res => {
          // this.connection.invoke("SendMessageToAdmin", "Employee Added").catch(function(err){
          //   return console.error(err.toString());
          // });
          this.isLoading = false;
          this.showModal = false;
          this.$message.success(
            "Congratulations! You have successfully accepted the job offer."
          );
          this.$router.push({
            name: "jobseeker-statusboard",
            params: { activeTab: "third" }
          });
        })
        .catch(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>
